import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './lib/theme';
import App from './App';
import './index.css';
// Every page on the site (landing + account-lifecycle + legal) shares this
// one design system, so it's loaded once at the entry point.
import './components/cinematic/cinematic.css';

// No StrictMode: its dev-only double mount re-creates the WebGL context and
// replays entrance animations, which reads as hero flicker. All cinematic
// effects are written fromTo/idempotent, so we don't rely on it for safety.
// No AuthProvider: authentication lives exclusively in the mobile app. The
// account-lifecycle pages (register/verify/reset) call authApi directly and
// never persist a browser session.
createRoot(document.getElementById('root')!).render(
  <ThemeProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);
